const isItemVisible = (item, navigationMeta) => {
  if (item.requiresProfile && !navigationMeta.hasProfile) {
    return false;
  }
  if (item.requiresAccounting && !navigationMeta.hasAccounting) {
    return false;
  }
  if (item.requiresRoleAdmin && !navigationMeta.canAccessRoleAdmin) {
    return false;
  }
  if (item.requiresApprovals && !navigationMeta.canAccessApprovals) {
    return false;
  }
  if (item.showWhen && !item.showWhen(navigationMeta)) {
    return false;
  }
  if (item.hideWhen && item.hideWhen(navigationMeta)) {
    return false;
  }
  return true;
};

export const buildNavigationSections = (config, navigationMeta) => {
  return config
    .map((section) => {
      const visibleItems = section.items
        .map((item) => {
          if (!isItemVisible(item, navigationMeta)) {
            return null;
          }
          const children = Array.isArray(item.children)
            ? item.children.filter((child) => isItemVisible(child, navigationMeta))
            : [];
          if (!item.path && children.length === 0) {
            return null;
          }
          return {
            ...item,
            ...(children.length > 0 ? {children} : {}),
          };
        })
        .filter(Boolean);

      return {
        ...section,
        items: visibleItems,
      };
    })
    .filter((section) => section.items.length > 0);
};
